import { environment } from './../../../../environment/environment';
import { ApiResponse } from './../../../core/models/response-api';
import { Injectable } from '@angular/core';
import { CrudService } from '../crud-service/crud.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class TutoService extends CrudService<ApiResponse<any>, number> {
  public endpoint_tuto = '/api/Tuto/getBytype/2?';
  public endpoint_tuto1 = '/api/Tuto/getBytype/3?';

  constructor(_http: HttpClient) {
    super(_http, `${environment.baseUrl}`);
  }

  /* get list tuto  */
  getAllTuto(data: {
    per_page?: number;
    page?: number;
  }){
    let page = 1 
    if(data?.page){
      page=data?.page + 1
    }
    return this._http.get<ApiResponse<any>>(
      this._base + this.endpoint_tuto + 'per_page=' + data?.per_page + '&page=' + page
    );
  }
  getAllTutoclient(
    perpage: number,
    page: number
  ): Observable<ApiResponse<any>> {
    return this._http.get<ApiResponse<any>>(
      this._base + this.endpoint_tuto1 + 'per_page=' + perpage + '&page=' + page
    );
  }

  searchtuto(data: any) {
    let page =1
    if(data?.page){
      data.page = data.page + 1;
    }
    return this._http.post<ApiResponse<any>>(
      this._base + `/api/Tuto/filterbytype`,
      data
    );
  }
}
